export const API_EXTERNAL_ENDPOINT = 'travelers/optIn'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/travelers/optIn'
